var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftLineBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 512",
    enableBackground: "new 0 0 640 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0,80c0-8.84,7.164-16,16-16c8.84,0,16,7.16,16,16v352c0,8.8-7.16,16-16,16c-8.836,0-16-7.2-16-16V80z  M100.7,244.7l144-144c6.2-6.26,16.4-6.26,22.6,0c6.3,6.2,6.3,16.4,0,22.6L150.6,239.1H624c8.8,0,16,8.1,16,16c0,9.7-7.2,16-16,16 H150.6l116.7,117.6c6.3,6.2,6.3,16.4,0,22.6c-6.2,6.3-16.4,6.3-22.6,0l-144-144c-3.14-3.1-4.7-7.2-4.7-12.2 C96,251.9,97.56,247.8,100.7,244.7L100.7,244.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLineBlack);
export default __webpack_public_path__ + "static/media/arrow-left-line-black.60f50fcaa0dd34a84f9c142276a992f9.svg";
export { ForwardRef as ReactComponent };